import React, { useState } from 'react';
import { sifreSifirlamaTalep } from '../services/apiService';
import {
  HiMail,
  HiX,
  HiCheckCircle,
  HiShieldCheck,
  HiInformationCircle
} from 'react-icons/hi';
import toast from 'react-hot-toast';
import './ForgotPasswordModal.css';

const ForgotPasswordModal = ({ onClose }) => {
  const [email, setEmail] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Backend API'ye istek gönder
      const response = await sifreSifirlamaTalep(username, email);

      if (response.success) {
        // Başarılı durum
        setSuccess(true);
        toast.success(response.mesaj || 'Şifre sıfırlama talimatları e-posta adresinize gönderildi!');

        // 3 saniye sonra modal'ı kapat
        setTimeout(() => {
          onClose();
        }, 3000);
      } else {
        toast.error(response.mesaj || 'Şifre sıfırlama talebi gönderilemedi.');
        setLoading(false);
      }
    } catch (err) {
      toast.error('Bir hata oluştu. Lütfen tekrar deneyin.');
      setLoading(false);
    }
  };

  return (
    <div className="forgot-modal-overlay" onClick={onClose}>
      <div className="forgot-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="forgot-modal-header">
          <div className="header-title">
            <div className="header-icon">
              <HiShieldCheck />
            </div>
            <h2>Şifremi Unuttum</h2>
          </div>
          <button className="forgot-modal-close" onClick={onClose}>
            <HiX />
          </button>
        </div>

        {!success ? (
          <form onSubmit={handleSubmit} className="forgot-form">
            <div className="info-banner">
              <HiInformationCircle />
              <p>
                Şifrenizi sıfırlamak için kayıtlı e-posta adresinizi ve kullanıcı adınızı girin.
                Size şifre sıfırlama talimatları göndereceğiz.
              </p>
            </div>

            <div className="forgot-form-group">
              <label htmlFor="username" className="forgot-form-label">
                <HiShieldCheck />
                <span>Kullanıcı Adı</span>
              </label>
              <input
                id="username"
                type="text"
                className="forgot-form-input"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Kullanıcı adınızı girin"
                required
                autoFocus
              />
            </div>

            <div className="forgot-form-group">
              <label htmlFor="email" className="forgot-form-label">
                <HiMail />
                <span>E-posta Adresi</span>
              </label>
              <input
                id="email"
                type="email"
                className="forgot-form-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="E-posta adresinizi girin"
                required
              />
              <p className="forgot-hint">Hesabınıza kayıtlı e-posta adresini girin</p>
            </div>

            <div className="forgot-modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                İptal
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <div className="spinner-sm"></div>
                    <span>Gönderiliyor...</span>
                  </>
                ) : (
                  <>
                    <HiMail />
                    <span>Gönder</span>
                  </>
                )}
              </button>
            </div>
          </form>
        ) : (
          <div className="success-message">
            <div className="success-icon-large">
              <HiCheckCircle />
            </div>
            <h3>E-posta Gönderildi!</h3>
            <p>
              Şifre sıfırlama talimatları e-posta adresinize gönderildi.
              Lütfen gelen kutunuzu kontrol edin.
            </p>
            <p className="hint-text">
              E-postayı görmüyorsanız spam klasörünüzü kontrol edin.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordModal;
